module.exports = [
  {
    __typename: 'WpPage_Pagebuilder_Layouts_Hero',
    kicker: 'LeadBoxer Platform',
    heading: 'Lead & Customer Intelligence',
    text: `<p>Identify your most qualified Leads & Customers and insert valuable insights into your sales workflow.</p>`,
    buttons: [
      {
        label: 'Request demo',
        type: 'primary',
        destination: {
          __typename: 'WpPage',
          uri: 'https://www.leadboxer.com/demo/',
        },
      },
      {
        label: 'View case studies',
        type: 'text',
        icon: {
          position: 'right',
          name: 'RiArrowRightLine',
          color: 'primary',
        },
        destination: {
          __typename: 'WpPage',
          uri: '/cases/',
        },
      },
    ],
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_Clients',
    divider: {
      text: 'Loved by startups. Trusted by enterprises.',
      callToAction: {
        label: 'View case studies',
        uri: '/cases/',
      },
    },
  },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_Capterra',
  //   quote: `“Strong lead gen software that connects to all existing systems”`,
  //   uri: `https://www.capterra.com/p/141290/LeadBoxer/`,
  // },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_Features',
    kicker: 'Platform Features',
    heading: 'Take a look at the Features and Benefits of using LeadBoxer',
    features: [
      {
        icon: {
          name: 'RiGitMergeLine',
          color: 'primary',
        },
        heading: 'Integrations & Connectors',
        text: `We support many integrations out-of-the-box, to collect your data and get the results in your workflow.`,
      },
      {
        icon: {
          name: 'RiAppsFill',
          color: 'accent-01',
        },
        heading: 'Flexible',
        text: `Built with flexibility in mind, we support various  workflows, data-sources, destinations and tool-stacks.`,
      },
      {
        icon: {
          name: 'RiDashboardFill',
          color: 'accent-02',
        },
        heading: 'Application & API',
        text: `You can use our modern (web) application or get the (raw) data through our world-class API.`,
      },
      {
        icon: {
          name: 'RiAncientPavilionLine',
          color: 'accent-03',
        },
        heading: 'Leads, Customer, Accounts',
        text: `Your audience consists of individual leads, existing customers, named accounts and more. We support all.`,
      },
      {
        icon: {
          name: 'RiTodoLine',
          color: 'accent-04',
        },
        heading: 'Documentation & Tutorials',
        text: `Over the years, we have created many different  tutorials, manuals and guidelines. Ready to learn?`,
      },
      {
        icon: {
          name: 'RiSeedlingFill',
          color: 'accent-05',
        },
        heading: 'Build for Scale',
        text: `The more data the better, as we are experts in finding needles in your haystack of lead & customer data.`,
      },
    ],
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TextMedia',
    kicker: 'What LeadBoxer does?',
    heading: 'We make it easy to find your best Leads and Customers',
    text: `
      <p>
      LeadBoxer is a platform designed to optimise workflow regarding online lead & customer identification and qualification. Integrate all lead and customer profile behavioural data together to discover new opportunities for your organisation.
      </p>
      <ul>
        <li>Cutting edge big-data technology</li>
        <li>Identify, capture, enrich, score, segment your leads and customers.</li>
        <li>Access to Customer Intelligence Experts and Engineering team ready to help.</li>
      </ul>
      `,
    buttons: [
      {
        label: 'Schedule a call',
        type: 'primary',
        destination: {
          uri: 'https://www.leadboxer.com/demo/',
        },
      },
      {
        label: 'All platform features',
        type: 'text',
        destination: {
          uri: '/platform',
        },
      },
    ],
    media: {
      align: 'left',
      type: {
        name: 'placeholder',
        // image: {
        //   background: false,
        //   altText: '',
        //   title: 'leadboxer-platform-features',
        //   description: '',
        // },
      },
    },
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TextMedia',
    kicker: 'Platform',
    heading: 'Turn Data into Insights',
    text: `
      <p>
      Our modern web application allows you and your colleagues to access and find the insights they are looking for. Easily created segments, modify lead-scoring or setup notifcations.
      </p>
      `,
    buttons: [
      {
        label: 'Schedule a call',
        type: 'primary',
        destination: {
          uri: 'https://www.leadboxer.com/demo/',
        },
      },
      {
        label: 'Start a free trial',
        type: 'text',
        destination: {
          uri: '/start',
        },
      },
    ],
    media: {
      align: 'right',
      type: {
        name: 'placeholder',
        // image: {
        //   background: false,
        //   altText: '',
        //   title: 'leadboxer-platform-features',
        //   description: '',
        // },
      },
    },
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TextMedia',
    backgroundColor: 'dark',
    kicker: 'B2B Growth Podcast',
    heading: 'The Power of LeadBoxer in Getting the Most Out of Your Leads',
    text: `
        <p>Hear Wart Fransen, one of LeadBoxers founders explain in clear language what LeadBoxer is, how it works and how it can benefit your organization.</p>
      `,
    buttons: [
      {
        label: 'Schedule a call',
        type: 'primary',
        destination: {
          __typename: 'WpPage',
          uri: 'https://www.leadboxer.com/demo/',
        },
      },
    ],
    media: {
      align: 'left',
      type: {
        name: 'embed',
        embed: `<iframe src="https://open.spotify.com/embed/episode/4ZrTDeeZDXGceN65nTzpuI" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`,
        // image: {
        //   background: false,
        //   altText: '',
        //   title: 'leadboxer-platform-features',
        //   description: '',
        // },
        // component: 'placeholder',
      },
    },
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TextMedia',
    kicker: 'Integrations & Connectors',
    heading: 'Integrate with the the tools you already use.',
    text: `
        <p>Our goal is to work with your existing technology stack (the tools you already use). Our role is to push the data and insights to where they need to go. We have developed native integrations with many tools and are constantly adding new ones. We also support all major email marketing automation tools for newsletter and email tracking and identification.</p>
      `,
    buttons: [
      {
        label: 'Schedule a call',
        type: 'primary',
        destination: {
          __typename: 'WpPage',
          uri: '/cases/',
        },
      },
      {
        label: 'View Case Studies',
        type: 'text',
        destination: {
          __typename: 'WpPage',
          uri: '/start/',
        },
      },
    ],
    media: {
      align: 'left',
      type: {
        name: 'image',
        image: {
          align: 'right',
          background: false,
          altText: '',
          title: 'leadboxer-integrations',
          description: '',
        },
      },
    },
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TextMedia',
    backgroundColor: 'bg-gray-100',
    kicker: 'Case Studies',
    heading: 'Build your case, read some of our case-studies.',
    text: `
        <p>Don’t take our word for it – let these case studies convince you by demonstrating our knowledge and expertise in corporate environments.</p>
      `,
    buttons: [
      {
        label: 'All Case Studies',
        type: 'primary',
        destination: {
          __typename: 'WpPage',
          uri: '/start/',
        },
      },
      {
        label: 'Schedule a call',
        type: 'text',
        destination: {
          __typename: 'WpPage',
          uri: '/cases/',
        },
      },
    ],
    media: {
      align: 'right',
      type: {
        name: 'image',
        image: {
          align: 'right',
          background: false,
          altText: '',
          title: 'LeadBoxer-Case-Studies',
          description: '',
        },
      },
    },
    // image: {
    //   align: 'right',
    //   background: false,
    //   altText: '',
    //   title: 'leadboxer-case-study-mockup',
    //   description: '',
    // },
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TempBlog',
    kicker: 'Marketing & Lead Generation Blog',
    heading: 'Check our latest insights on Marketing and Lead Generation',
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TextMedia',
    kicker: 'What LeadBoxer does?',
    heading: 'We make it easy to find your best Leads and Customers',
    text: `
      <p>
      LeadBoxer is a platform designed to optimise workflow regarding online lead & customer identification and qualification. Integrate all lead and customer profile behavioural data together to discover new opportunities for your organisation.
      </p>
      <ul>
        <li>Cutting edge big-data technology</li>
        <li>Identify, capture, enrich, score, segment your leads and customers.</li>
        <li>Access to Customer Intelligence Experts and Engineering team ready to help.</li>
      </ul>
      `,
    buttons: [
      {
        label: 'Schedule a call',
        type: 'primary',
        destination: {
          uri: 'https://www.leadboxer.com/demo/',
        },
      },
      {
        label: 'All platform features',
        type: 'text',
        destination: {
          uri: '/platform',
        },
      },
    ],
    media: {
      align: 'left',
      type: {
        name: 'placeholder',
        // image: {
        //   background: false,
        //   altText: '',
        //   title: 'leadboxer-platform-features',
        //   description: '',
        // },
      },
    },
  },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_TempTestimonials',
  //   kicker: 'Testimonials & reviews',
  //   heading: 'What our customers are saying',
  //   testimonials: [
  //     {
  //       testimonial: `With LeadBoxer, I am able to get the data i need. If data is important to you, I would recommend this platform wholeheartedly!`,
  //       author: 'Martijn Ceelen',
  //       role: 'Principal BI Consultant, iConsultancy',
  //       rating: 5,
  //       picture: {
  //         altText: '',
  //         title: 'martijn-ceelen',
  //         description: '',
  //       },
  //     },
  //     {
  //       testimonial: `LeadBoxer has the best identification and company data that I have found to date.`,
  //       author: 'Martijn Arts',
  //       role: 'Partner & Strategy Director, Total Design',
  //       rating: 5,
  //       picture: {
  //         altText: '',
  //         title: 'martijn-arts',
  //         description: '',
  //       },
  //     },
  //     {
  //       testimonial: `LeadBoxer is addictive! The information provided just keeps amazing me.`,
  //       author: 'Rune Theill',
  //       role: 'Co-founder & CEO, Rockstart',
  //       rating: 5,
  //       picture: {
  //         altText: '',
  //         title: 'rune-theill',
  //         description: '',
  //       },
  //     },
  //   ],
  // },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //   kicker: 'Platform',
  //   heading: 'Turn Data into Insights',
  //   text: `
  //       <p>Our modern web application allows you and your colleagues to access and find the insights they are looking for. Easily created segments, modify lead-scoring or setup notifcations.</p>
  //     `,
  //   buttons: [
  //     {
  //       label: 'Schedule a call',
  //       type: 'primary',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: 'https://www.leadboxer.com/demo/',
  //       },
  //     },
  //     {
  //       label: 'Start a free trial',
  //       type: 'text',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/start/',
  //       },
  //     },
  //   ],
  //   image: {
  //     align: 'right',
  //     background: false,
  //     altText: '',
  //     title: 'leadboxer-data-insights',
  //     description: '',
  //   },
  // },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //   backgroundColor: 'dark',
  //   kicker: 'B2B Growth Podcast',
  //   heading: 'The Power of LeadBoxer in Getting the Most Out of Your Leads',
  //   text: `
  //       <p>Hear Wart Fransen, one of LeadBoxers founders explain in clear language what LeadBoxer is, how it works and how it can benefit your organization.</p>
  //     `,
  //   buttons: [
  //     {
  //       label: 'Schedule a call',
  //       type: 'primary',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: 'https://www.leadboxer.com/demo/',
  //       },
  //     },
  //   ],
  //   image: [],
  //   embed: `<iframe src="https://open.spotify.com/embed/episode/4ZrTDeeZDXGceN65nTzpuI" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`,
  // },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //   kicker: 'Integrations & Connectors',
  //   heading: 'Integrate with the the tools you already use.',
  //   text: `
  //       <p>Our goal is to work with your existing technology stack (the tools you already use). Our role is to push the data and insights to where they need to go. We have developed native integrations with many tools and are constantly adding new ones. We also support all major email marketing automation tools for newsletter and email tracking and identification.</p>
  //     `,
  //   buttons: [
  //     {
  //       label: 'Schedule a call',
  //       type: 'primary',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/cases/',
  //       },
  //     },
  //     {
  //       label: 'View Case Studies',
  //       type: 'text',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/start/',
  //       },
  //     },
  //   ],
  //   image: {
  //     align: 'right',
  //     background: false,
  //     altText: '',
  //     title: 'leadboxer-integrations',
  //     description: '',
  //   },
  // },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_TempCaseStudies',
  //   backgroundColor: 'bg-gray-100',
  //   kicker: 'Case Studies',
  //   heading: 'Build your case, read some of our case-studies.',
  //   text: `
  //       <p>Don’t take our word for it – let these case studies convince you by demonstrating our knowledge and expertise in corporate environments.</p>
  //     `,
  //   buttons: [
  //     {
  //       label: 'Schedule a call',
  //       type: 'primary',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/cases/',
  //       },
  //     },
  //     {
  //       label: 'All Case Studies',
  //       type: 'text',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/start/',
  //       },
  //     },
  //   ],
  //   image: {
  //     align: 'right',
  //     background: false,
  //     altText: '',
  //     title: 'leadboxer-case-study-mockup',
  //     description: '',
  //   },
  // },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_TempBlog',
  // },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_TempTestimonials',
  //   kicker: 'Testimonials & reviews',
  //   heading: 'What our customers are saying',
  //   testimonials: [
  //     {
  //       testimonial: `With LeadBoxer, I am able to get the data i need. If data is important to you, I would recommend this platform wholeheartedly!`,
  //       author: 'Martijn Ceelen',
  //       role: 'Principal BI Consultant, iConsultancy',
  //       rating: 5,
  //       picture: {
  //         altText: '',
  //         title: 'martijn-ceelen',
  //         description: '',
  //       },
  //     },
  //     {
  //       testimonial: `LeadBoxer has the best identification and company data that I have found to date.`,
  //       author: 'Martijn Arts',
  //       role: 'Partner & Strategy Director, Total Design',
  //       rating: 5,
  //       picture: {
  //         altText: '',
  //         title: 'martijn-arts',
  //         description: '',
  //       },
  //     },
  //     {
  //       testimonial: `LeadBoxer is addictive! The information provided just keeps amazing me.`,
  //       author: 'Rune Theill',
  //       role: 'Co-founder & CEO, Rockstart',
  //       rating: 5,
  //       picture: {
  //         altText: '',
  //         title: 'rune-theill',
  //         description: '',
  //       },
  //     },
  //   ],
  // },
  // Keep this for reference
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_Test',
  //   kicker: 'Integrations & Connectors',
  //   heading: 'Integrate with the the tools you already use.',
  //   text: `
  //       <p>Our goal is to work with your existing technology stack (the tools you already use). Our role is to push the data and insights to where they need to go. We have developed native integrations with many tools and are constantly adding new ones. We also support all major email marketing automation tools for newsletter and email tracking and identification.</p>
  //     `,
  //   buttons: [
  //     {
  //       label: 'Schedule a call',
  //       type: 'primary',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/demo/',
  //       },
  //     },
  //     {
  //       label: 'View Case Studies',
  //       type: 'text',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/cases/',
  //       },
  //     },
  //   ],
  //   image: {
  //     align: 'right',
  //     background: false,
  //     altText: '',
  //     title: 'leadboxer-platform-features',
  //     description: '',
  //     localFile: {
  //       publicURL:
  //         '/static/e69461f9f4701170d3e254d0467bb29c/LeadBoxer_Product_LowFi.svg',
  //       childImageSharp: null,
  //     },
  //   },
  // },
]
